<template>
  <div>
    <div class="camera-viewport">
      <div
        id="qr-viewfinder"
        class="camera"
      />
      <div class="camera-loader">
        <div class="loader no-spacing" />
      </div>
    </div>

    <div
      v-if="showCameraSelect"
      class="section center section--half-padding"
    >
      <h2 class="title title--4">Select a camera:</h2>
      <button
        v-for="device in devices"
        :key="device.id"
        class="button button--primary"
        type="button"
        @click="handleSelectCameraClick(device.id)"
      >
        {{ device.label }}
      </button>
    </div>
  </div>
</template>

<script>
  import { Html5Qrcode } from 'html5-qrcode';

  import logger from '@/services/logger';

  export default {
    name: 'BarcodeScanner',

    data() {
      return {
        html5QrcodeScanner: null,
        devices: [],
        showCameraSelect: false
      };
    },

    mounted() {
      this.onComponentMounted();
    },

    unmounted() {
      this.onComponentDestroyed();
    },

    methods: {
      async onComponentMounted() {
        this.html5QrcodeScanner = new Html5Qrcode(
          'qr-viewfinder',
          /** Supported formats are internally mapped via: https://github.com/mebjas/html5-qrcode/blob/master/src/core.ts#L14 */
          {
            formatsToSupport: [0, 3, 5, 9, 10, 11]
          },
          false
        );

        this.devices = await Html5Qrcode.getCameras();

        if (this.devices.length === 1) {
          this.handleSelectCameraClick(this.devices[0].id);
        }
        else {
          this.showCameraSelect = true;
        }
      },

      async onComponentDestroyed() {
        if (this.html5QrcodeScanner) {
          try {
            await this.html5QrcodeScanner.stop();
          }
          catch (err) {
            logger.error(err);
          }
        }
      },

      async handleSelectCameraClick(cameraId) {
        this.showCameraSelect = false;

        await this.html5QrcodeScanner.start(
          cameraId,
          {
            aspectRatio: 1,
            qrbox: this.$el.clientWidth - 75
          },
          this.onScanSuccess
        );
      },

      async onScanSuccess(decodedText) {
        try {
          await this.html5QrcodeScanner.stop();

          const claimPayload = { type: 'posReceiptToken', value: decodedText.trim() };

          await this.$store.dispatch('offers/claimPreviousOrder', claimPayload);
        }
        catch (error) {
          logger.error(error);
        }
        finally {
          this.$closeModal('barcodeScanner');
        }
      }
    }
  };
</script>

<style lang="sass" scoped>
  .camera-viewport
    min-height: 250px
    position: relative

  .camera-loader
    position: absolute
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)

  .camera
    z-index: 100
</style>
